import React, { } from 'react';
import { useMapEvents } from 'react-leaflet';

export interface MapEventsProps {
  onCenterChange: (center: [number, number]) => void;
  onZoomChange: (zoom: number) => void;
}

export const MapEvents: React.FC<MapEventsProps> = ({ onCenterChange, onZoomChange }: MapEventsProps) => {
  const map = useMapEvents({
    moveend: () => {
      const center = map.getCenter();
      onCenterChange([center.lat, center.lng]);
    },
    zoomend: () => {
      const zoom = map.getZoom();
      onZoomChange(zoom);
    }
  });
  return null;
};